window.infiniteScroll = {

  // variável criada no arquivo _infinity_scroll.liquid
  pagination: window._pagination,

  // wrapper que contém/recebe os produtos
  productsWrapper: document.querySelector('[data-products-wrapper]'),

  // elemento que ativa a busca por mais produtos
  loadEl: document.querySelector('[data-load-more]'),

  stopLoading: function() {
    const loadEl = this.loadEl;
    if (loadEl != null) loadEl.parentElement.removeChild(loadEl);
  },

  setCurrentPage: function (_number) {
    const _this = this;
    const totalPages = _this.pagination.total_pages;

    // Verifica se a página atual não é maior que o total de páginas
    if (_number <= totalPages) {

      // Atualiza a página atual
      _this.pagination.current_page = _number;

      // Desabilita prosseguimento caso tenha chegado na última página, removendo o elemento que dá trigger
      if (_this.pagination.current_page >= totalPages) _this.stopLoading();

      // Atualiza a URL da próxima página
      if (_number < totalPages)
        return _this.pagination.next_url = _this.pagination.pages[_number].url
    }
  },

  loadProducts: async function() {
    const nextUrl = this.pagination.next_url;
  
    console.log('nextUrl', nextUrl);

    // Busca próxima leva de produtos
    const response = await fetch(nextUrl);
    const data = await response.text();

    // Parse
    const parser = new DOMParser();
    const doc = parser.parseFromString(data, "text/html");

    // Busca por script de adição no carrinho pela tag
    const scripts = doc.querySelectorAll('[data-product-scripts]');
    // console.log('scripts', scripts);

    scripts.forEach(script => { eval(script.innerText) })

    // Retorno dos produtos
    return doc.querySelectorAll('.product-block');
  },

  getNextPage: async function() {
    const _this = this;
    const currentPage = _this.pagination.current_page;
    const wrapper = _this.productsWrapper;

    if (!wrapper.classList.contains('searching')) {

      // Busca e adiciona novos produtos
      _this.productsWrapper.classList.add('searching');
      const newProducts = await _this.loadProducts();
      newProducts.forEach(product => {
        wrapper.appendChild(product);
       });

      store.setQuickView();
      window.store.setImagesBetweenProducts();

      // Atualiza página atual carregada e próxima etapa se tiver
      _this.setCurrentPage(currentPage + 1);

      // Atualiza o lazy load
      lazyLoadInstance.update();

      // Busca preços por ajax
      window.store.getPriceProd();

      // Atualiza imagens/cores dos produtos
      window.template_store.setProductBlockImages();

      // libera o processo de busca de novas páginas
      wrapper.classList.remove('searching');
    }
  },

  init: function() {
    const _this = this;
    const loadEl = _this.loadEl;

    // Verifica se há paginação definida antes de iniciar
    if (typeof _this.pagination != undefined) {

      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })

      if (loadEl != null) {
        // Inicia com clique no botão
        loadEl.addEventListener('click', () => { _this.getNextPage() })
      }
    }
  }
}

window.addEventListener('load', () => { infiniteScroll.init() })
